import React from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import Label from '../../typography/Label';
import AlertIcon from '../../icons/utility/AlertIcon';
import InputError from '../InputError';
import withFormErrors from '../../hocs/withFormErrors';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import withFocus from '../../hocs/withFocus';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
export const TextArea = React.forwardRef(({ maxLength, rows, cols, resize, name, displayName, placeholder = '', required = false, size = 'large', disabled = false, showErrMessage = true, styles, errorId, errorMessage, isFocused, handleFocus, handleBlur, onBlur, ...rest }, ref) => {
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const { borders, sizing: { widths }, inputs: { base, size: sizeStyles, disabled: disabledInputStyles, utilityIconStyles }, utility: { size: { fullWidthStyles } } } = useTheme();
    const marginStyles = useComponentMargin({
        marginVertical: 'small',
        ...(!errorId && { marginBottom: 'regular' })
    });
    const mergedStyles = {
        ...base,
        ...sizeStyles.regular,
        ...fullWidthStyles,
        ...(disabled && disabledInputStyles),
        ...(!isFocused && borders.variant.secondary),
        // error styles MUST come after active styles to override them
        ...(!!errorId && borders.error),
        lineHeight: 1.5,
        padding: '15px 30px',
        borderRadius: '2.6rem',
        ...(resize && { resize }),
        ...marginStyles,
        ...styles
    };
    const wrapperStyles = {
        width: widths.input[size],
        position: 'relative'
    };
    return (React.createElement("div", { style: wrapperStyles },
        React.createElement(Label, { htmlFor: name, required: required, disabled: disabled }, displayName),
        React.createElement("textarea", { maxLength: maxLength, rows: rows, cols: cols, placeholder: placeholder, id: name, name: name, required: required, disabled: disabled, style: mergedStyles, "aria-invalid": !!errorId, "aria-describedby": errorId, ref: ref, ...focusHandlers, ...rest }),
        errorId && React.createElement(AlertIcon, { size: "utility", styles: utilityIconStyles }),
        showErrMessage && errorId && errorMessage && (React.createElement(InputError, { id: errorId }, errorMessage))));
});
export default withFormErrors(withFormProps(withFocus(TextArea)));
//# sourceMappingURL=index.js.map